module.exports = new __parcel__URL__("historical-cycle-time-app-skeleton.tpl.38a0478d.svg").toString();